import { ColumnsType } from 'antd/es/table/Table';
import { format } from 'date-fns';
import { formatCsvDate } from 'modules/dashboard/utils/csvDate';

export interface ILocationEntry {
  locationId: string;
  locationName: string;
  regionName?: string;
  totalActiveDonors: number;
  latestDonation?: string;
}

export const LOCATION_COLUMNS: ColumnsType<ILocationEntry> = [
  {
    title: 'Location Name',
    dataIndex: 'locationName',
    key: 'locationName',
    sorter: (a, b) => a.locationName.localeCompare(b.locationName),
  },
  {
    title: 'Region',
    dataIndex: 'regionName',
    key: 'regionName',
    render: (val: string | undefined) => val ?? '—',
    sorter: (a, b) => (a.regionName || '').localeCompare(b.regionName || ''),
  },
  {
    title: 'Total Active Donors',
    dataIndex: 'totalActiveDonors',
    key: 'totalActiveDonors',
    align: 'center',
    sorter: (a, b) => a.totalActiveDonors - b.totalActiveDonors,
    defaultSortOrder: 'descend',
  },
  {
    title: 'Latest Donation',
    dataIndex: 'latestDonation',
    key: 'latestDonation',
    render: (val: string | null) => {
      if (!val) return '—';
      return format(new Date(val), 'MM/dd/yyyy h:mm a');
    },
    sorter: (a, b) => {
      const aTime = a.latestDonation ? new Date(a.latestDonation).getTime() : 0;
      const bTime = b.latestDonation ? new Date(b.latestDonation).getTime() : 0;
      return aTime - bTime;
    },
  },
];

export const LOCATION_CSV_EXTRACTORS: Record<
  string,
  (e: ILocationEntry) => string
> = {
  locationName: (e) => e.locationName,
  regionName: (e) => e.regionName || '',
  totalActiveDonors: (e) => String(e.totalActiveDonors),
  latestDonation: (e) =>
    e.latestDonation ? formatCsvDate(e.latestDonation) : '',
};
